import { Image } from 'antd';
import React, { useEffect, useRef } from 'react';
import bg1 from '../images/tongueGuide/bg-1.png';
import bg2 from '../images/tongueGuide/bg-2.png';
import bg3 from '../images/tongueGuide/bg-3.png';
import bg4 from '../images/tongueGuide/bg-4.png';
import bg5 from '../images/tongueGuide/bg-5.png';
import bg6 from '../images/tongueGuide/bg-6.png';
import Tools, { config } from '../utils/tools';
import JsonRequest from '../components/jsonRequest';
import WechatOpenAppButton from './components/WechatOpenAppButton';

const TongueGuide: React.FC<any> = () => {
    const openBtn = useRef<any>(null);
    const guideImages = [bg1, bg2, bg3, bg4, bg5, bg6];

    useEffect(() => {
        if (Tools.isWechat() && window.wx) {
            JsonRequest.rawClient().get(`/common/wechat-web-evoke-app`, {
                url: window.location.href.split('#')[0]
            })
                .then((resp: any) => resp.json())
                .then(async ({ data }: any) => {
                    window.wx.config({
                        ...data,
                        jsApiList: [],
                        openTagList: ['wx-open-launch-app'] // 开放标签列表
                    });

                    const launchFunc = function () {
                        Tools.copy(window.location.href);
                    };

                    const errFunc = function (err: any) {
                        if (Tools.isIOS()) {
                            window.location.href = config.appStoreUrl;
                            alert("您还没有安装知源把脉养生或者版本需要升级");
                        } else if (Tools.isAndroid()) {
                            // window.open(config.androidStoreUrl, '_blank');
                            alert("您还没有安装知源把脉养生或者版本需要升级，请点击右上角菜单，选择「在浏览器中打开」下载App");
                        }
                        Tools.copy(window.location.href);
                    };

                    openBtn.current?.addEventListener("launch", launchFunc);
                    openBtn.current?.addEventListener("error", errFunc);

                    return () => {
                        openBtn.current?.removeEventListener("launch", launchFunc);
                        openBtn.current?.removeEventListener("error", errFunc);
                    };
                });
        }
    }, [openBtn]);

    return (
        <div style={{ backgroundColor: '#EAFAFF', paddingBottom: '40px', textAlign: 'center' }}>
            {guideImages.map((image, index) => (
                <div key={index}>
                    <Image
                        src={image}
                        alt={`舌诊指南-${index + 1}`}
                        style={{
                            maxWidth: '100%',
                            height: 'auto',
                        }}
                        preview={false}
                    />
                </div>
            ))}
            <div style={{ width: '80%', margin: '0 auto' }}>
                <WechatOpenAppButton
                    style={{
                        width: '100%',
                        color: 'white',
                        border: 'none',
                        padding: '12px 24px',
                        fontSize: '14px',
                        cursor: 'pointer',
                        backgroundColor: '#58BEBF',
                        borderRadius: '22px',
                    }}
                    buttonText="App内打开"
                />
            </div>
        </div>
    );
};

export default TongueGuide;